<template>
  <v-row class="align-center">
    <v-col cols="3" class="subtitle-2 text-grey-darken-1">FOC</v-col>

    <v-col>
      <div v-if="value" class="d-flex align-center">
        <span class="mr-2 text-capitalize">{{ formattedMode }}</span>

        <div v-if="value.mode !== 'no'" class="d-flex align-center">
          <f-number :value="value.value" @input="patch('value', $event)" />
          <span class="mx-1">/</span>
          <f-number :value="value.per" @input="patch('per', $event)" />
        </div>

        <v-btn icon x-small class="ml-1" @click="clear">
          <v-icon small>clear</v-icon>
        </v-btn>
      </div>

      <div v-else>
        <v-btn
          v-for="opt in options"
          :key="opt.id"
          x-small
          class="mx-1 cyoa-btn"
          color="grey lighten-1"
          @click="add(opt.id)"
        >
          {{ opt.label }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    supplierType: String,
    value: Object, // Shape: { mode: string, value: number, per: number }
  },
  data() {
    return {
      options:
        this.supplierType === "HOTEL"
          ? [
              { id: "Cumulative", label: "Cumulative" },
              { id: "PerNight", label: "Per Night" },
              { id: "no", label: "No" },
            ]
          : this.supplierType === "RESTAURANT"
            ? [
                { id: "PerPerson", label: "Per Person" },
                { id: "no", label: "No" },
              ]
            : [],
    };
  },
  computed: {
    formattedMode() {
      return this.value?.mode?.replace("_", " ");
    },
  },
  methods: {
    add(mode) {
      this.$emit("input", { mode, value: 0, per: 0 });
    },
    patch(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    clear() {
      this.$emit("input", null);
    },
  },
};
</script>
